import React from 'react';
import './simple_page.css';


const FailedRegistration = () => {


    return (
        <div className="todoqu-simple-text">
            <h3>Account activation failed!</h3>
            <h3>Please retry account creation, or double-check you&apos;ve used the correct email.</h3>
        </div>
    );
}

export default FailedRegistration;
